export default __webpack_public_path__ + "static/media/road_sweeper.c838607f.svg";